import http from '@/utils/http';
import { getFilterListRegions } from './filter';
import type { IRegionType, IRegionValue, IDateType } from '@/pages/intelligence/types/common';
import type {
  IRegion,
  IPCConsoleGamesCompareTableResult,
  IPCConsoleGamesCompareTrendsResult,
} from '@/pages/intelligence/types/pcConsoleCompare';

export async function fetchGamesByKeyword(params: {
  entity_type: string;
  keyword: string;
  system_type: string;
}): Promise<any[]> {
  return http({
    url: '/api/v1/intelligence_pc/compare/comparePcConsoleSearch',
    method: 'post',
    data: params,
  }) as Promise<any>;
}

export async function fetchSimilarGames(params: {
  entity_type: string;
  game_ids: {
    entity_type: string;
    game_id: string;
  }[];
}): Promise<any> {
  return http({
    url: '/api/v1/intelligence_pc/compare/similarPcConsoleGame',
    method: 'post',
    data: params,
  }) as Promise<any>;
}

// 获取PCConsole 对比的表格数据
export async function fetchPCConsoleCompareTableResults(params: {
  entity_type: string[];
  game_ids: {
    entity_type: string;
    game_id: string;
    start_date: string;
    end_date: string;
  }[];
  data_sources: string[];
  metrics: string[];
  device: string[];
  segment: string[];
  region_type: IRegionType;
  regions: IRegionValue;
  is_country: number;
}): Promise<{
  compare_list: IPCConsoleGamesCompareTableResult[];
}> {
  // @ts-ignore
  return http({
    url: '/api/v1/intelligence_pc/compare/comparePcConsoleMetric',
    method: 'post',
    data: params,
  });
}

// 获取PCConsole 对比的折线图、指标累计值 数据
export async function fetchPCConsoleCompareTrendsResults(params: {
  entity_type: string[];
  game_ids: {
    entity_type: string;
    game_id: string;
    start_date: string;
    end_date: string;
  }[];
  data_sources: string[];
  metrics: string[];
  device: string[];
  segment: string[];
  region_type: IRegionType;
  regions: IRegionValue;
  launch_date: 0 | (number & {});
  period: IDateType;
  start_date: string;
  end_date: string;
}): Promise<{
  trends: IPCConsoleGamesCompareTrendsResult[];
}> {
  // @ts-ignore
  return http({
    url: '/api/v1/intelligence_pc/compare/comparePcConsoleTrend',
    method: 'post',
    data: params,
    original: true,
  });
}

// 下载，获取下载任务id，跳转到统一下载页面进行下载
export async function fetchDownloadTaskId(params: any): Promise<any> {
  // @ts-ignore
  return http({
    url: '/api/v1/intelligence_pc/compare/comparePcConsoleTrendExcel',
    method: 'post',
    data: params,
    errorHandler: true,
  });
}

// 获取国家筛选器选项数据
export async function fetchRegionsCountries(params: {
  filter_type: 'common' | 'newzoo' | (string & {});
  type: { tabName: 'mobile' | (string & {}) }[];
  item: { tabName: string }[];
}): Promise<IRegion[]> {
  return getFilterListRegions(params);
}
